<template>
<Card :bordered="false" :padding="0" dis-hover>
    <p  @click="toggle" style="cursor:pointer;" >
        <Row  type="flex" :gutter="0"  justify="start" align="middle" style="margin-bottom:14px;margin-top:14px;">
            <Col span="18">
                <CommonIcon type='_custom-pack' v-show="showForm" size="14"/> 
                 <CommonIcon  v-show="!showForm" type='_custom-spread' size="14"/>
                 <span style="margin-left:10px;font-size: 14px;font-weight:bold" v-text="myConfig.title" />
            </Col>
            <Col  v-show="showForm"  span="6">
            <Row  type="flex" justify="end" :gutter="0"  align="middle">
                <Dropdown  placement="bottom-start"  style="float:right">
                    <Button style="height:21px" type="info" @click.stop="doForm" >
                        更多操作
                        <Icon type="ios-arrow-down"></Icon>
                    </Button>
                    <DropdownMenu slot="list" >
                        <DropdownItem>
                            <Button  @click.stop="openForm" >全部展开</Button>
                        </DropdownItem>
                            <DropdownItem >
                            <Button   @click.stop="closeForm">全部收起</Button>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </Row>
            </Col>
        </Row>
    </p>
    <Divider style="margin-left:24px;margin-bottom:10px;margin-top: 0px;"/>
    <div style="margin-left:24px;" v-show="showForm" >
        <Row style="margin-bottom:10px;">
            <Button  style="padding-left:0px;padding-right:0px" customIcon="iconfont icon-custom-rowadd3"  type="text"  :disabled="btnReadOnly" @click="add" >添加</Button>
        </Row>   
        <FormDetail v-if="showAdd" ref="addform" :config="myConfig" :isAdd="true"   @doAction="newDoAction" :dictData="dictData"/>
        <FormDetail v-for="(temp,index) in data"  :ref="temp.index" :key="temp.index"  :valueData="temp" :curlIndex="index" :index="temp.index"  :config="myConfig"  @doAction="doAction" :dictData="dictData"/>
    </div>
</Card>
</template>

<script>
import FormDetail from './formdetailtwo.vue';
export default {
    name:'detail',
    components:{
        FormDetail
    },
    data () {
        return {
            readOnly:false,
            showAdd:false,
            isGrid:false,
            myConfig:{
                title:'',
                titleType:1,
                addBtnType:'1',
                hide:true,
                addBtnName:'新增',
                editBtnName:'编辑'
            },
            showForm:true,
            editFlag:false,
            showBtn:true,
            iconStyle:'',
            pStyle:'',
            data:[],
            delData:[],
            btnReadOnly:false
        };
    },
    props:{
        config:{
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        }
    },
    created () {
        this.init();
    },
    computed: {
    },
    methods:{
        init (){
            this.myConfig = Object.assign({},this.myConfig,this.config);
            delete this.myConfig.formConfig.name;
            delete this.myConfig.formConfig.title;
            delete this.myConfig.gridConfig.name;
            delete this.myConfig.gridConfig.title;
        },
        setShowGrid(value) {
            this.showForm = value;
        },
        toggle () {
            this.showForm = !this.showForm;
        },
        getRowObject(index) {
            if (this.$refs[index] && this.$refs[index][0]) {
                return this.$refs[index][0];
            }
            return null;
        },
        add (obj) {
            let row = null;
            if (this.myConfig.addRowBefore) {
                row = this.myConfig.addRowBefore();
                if (row === false) {
                    return;
                }
            }
            if (!row || row === true) {
                row = {};
            }
            if (obj) {
                row = Object.assign({},row, obj);
            }
            if (!this.showForm) {
                this.showForm = true;
            } 
            this.showAdd = true;
            let self = this;
            row.flag = 'I';
            self.$nextTick(() =>{
                self.$refs.addform.setData(row);
                self.$refs.addform.setFormReadOnly(false);
            });
        },
        newDoAction (obj) {
            if (this['new' + obj.name]) {
                this['new' + obj.name](obj);
            }
        },
        doAction(obj) {
            if (this[obj.name]) {
                this[obj.name](obj);
            }
        },
        newsaveForm (obj) {
            let temp = obj.para.data;
            temp.index = 'formdetail_' + this.data.length;
            temp.flag = 'I';
            this.data.push(temp);
            this.showAdd = false;
        },
        isChange () {
            let flag = false;
            if (this.data && this.data.length > 0) {
                this.data.forEach(el => {
                    if (!flag) {
                        if (this.$refs[el.index] && this.$refs[el.index][0]) {
                            flag = this.$refs[el.index][0].isChange();
                        }
                    }
                });
            }
            return flag;
        },
        isEdit() {
            return this.showAdd;
        },
        newcancelForm () {
            this.showAdd = false;
        },
        doAction (obj) {
            if (this[obj.name]) {
                this[obj.name](obj);
            }
        },
        getData (flag) {
            let data = [];
            this.data.forEach(el => {
                let obj = this.$Method.copy(el);
                if (!flag) {
                    delete obj.index;
                }
                data.push(obj);
            });
            return data;
        },
        setData (data) {
            this.data = [];
            this.delData = [];
            data.forEach((el, index) => {
                el.index = 'formdetail_' + index;
            });
            this.$nextTick(() => {
                this.data =this.$Method.copy(data);
            });
        },
        saveForm (obj) {
            let index = this.data.findIndex(el => el.index === obj.para.index);
            if (index > -1) {
                if (this.data[index].flag === undefined) {
                    obj.para.data.flag = 'U';
                }
                this.data.splice(index, 1, obj.para.data);
            }
        },
        delForm (obj) {
            this.delCommonForm(this.data, obj); 
        },
        delCommonForm(data, obj) {
            let index = data.findIndex(el => el.index === obj.para.index);
            let that  = this;
            if (index > -1) {
                if (this.myConfig.delRowBefore) {
                    let obj = {};
                    obj.index = index;
                    obj.gridObject = that;
                    obj.form = Object.assign({}, data[index]);
                    let flag = this.myConfig.delRowBefore(obj);
                    if (flag === false) {
                        return;
                    }
                }
                let form = this.$Method.copy(data[index]);
                if (form.flag === undefined  || form.flag === 'U') {
                    form.flag = 'D';
                    delete form.index;
                    this.delData.push(form);
                }
                data.splice(index, 1);
            }
        },
        editForm(obj) {
            this.showAdd = false;
            if (this.$refs.addform) {
                this.$refs.addform.clearData(obj);
            }
        },
        setReadOnly(value) {
            this.readOnly = value;
            this.$nextTick(() => {
                this.data.forEach(el => {
                    if (this.$refs[el.index] && this.$refs[el.index][0]) {
                        this.$refs[el.index][0].setReadOnly(value);
                    }
                });
            });
            if (this.readOnly) {
                this.showAdd = false;
            }
        },
        clearData () {
            this.data = [];
            this.delData = [];
            this.showAdd = false;
            if (this.$refs.addform) {
                this.$refs.addform.clearData();
            }
        },
        getChangeData() {
            return this.getCommonChangeData(this.data);
        },
        getCommonChangeData(data) {
            let changeData = [];
            if (data.length > 0) {
                data.forEach(el => {
                    if (this.$refs[el.index] && this.$refs[el.index][0]) {
                        if (this.$refs[el.index][0].isChange()) {
                            changeData.push(this.$refs[el.index][0].getChangeData());
                        }
                    } 
                });
            }
            return changeData.concat(this.delData);
        },
        editDetails() {
            if (this.checkIsEdit()) {
                this.editFlag = true;
                this.setReadOnly(false);
            } else {
                this.editFlag = false;
                this.setReadOnly(true);
            }
        },
        checkIsEdit() {
            let flag = true;
            if (this.myConfig.editObjectBefore) {
                flag = this.myConfig.editObjectBefore(this.myConfig.name);
            }
            return flag;
        },
        save () {
            if (this.checkValidate()){
                return;
            }
            let obj = {};
            obj.name = 'saveDetails';
            obj.detailsname = this.myConfig.name;
            this.editFlag = false;
            this.$emit('doAction', obj);
        },
        delRowData (obj) {
            this.delForm(obj);
        },
        checkValidate () {
            let flag = false;
            this.data.some(el => {
                if (this.$refs[el.index] && this.$refs[el.index][0]) {
                    flag = this.$refs[el.index][0].checkValidate();
                    if (flag) {
                        return true;
                    }
                }
            });
            if (flag) {
                this.alert('必填项不允许为空');
            }
            return flag;
        },
        cancel() {
            this.editFlag = false;
            this.delData = [];
        },
        setShowBtn(value) {
            this.showBtn = value;
        },
        setBtnReadOnly(value) {
            this.btnReadOnly = value;
        },
        openForm () {
            this.data.forEach(el => {
                if (this.$refs[el.index] && this.$refs[el.index][0]) {
                    this.$refs[el.index][0].setShowForm(true);
                }
            });
        },
        closeForm() {
            this.data.forEach(el => {
                if (this.$refs[el.index] && this.$refs[el.index][0]) {
                    this.$refs[el.index][0].setShowForm(false);
                }
            });
            this.showAdd = false;
        },
    },
    mounted () {
    }
};
</script>



// WEBPACK FOOTER //
// src/components/masterplate/detailsbox.vue